var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container background__color--white" }, [
    _vm.productsList.length < 1 && !_vm.hidePreloader
      ? _c(
          "div",
          {
            staticClass: "row animate__animated",
            class: { animate__fadeOut: _vm.hidePreloader },
          },
          [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]
        )
      : _vm.productsList.length >= 1
      ? _c("div", {}, [
          _c(
            "div",
            {
              staticClass: "row overflow-hidden",
              attrs: { id: "box-container" },
            },
            _vm._l(_vm.productsList, function (product, index) {
              return _c(
                "div",
                {
                  key: product.ID,
                  staticClass:
                    "col-12 col-md-6 col-lg-4 product-box text-center",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "product-box__link d-flex flex-column justify-content-between",
                      attrs: { href: product.url },
                    },
                    [
                      _c("div", {}, [
                        _c(
                          "div",
                          { staticClass: "product-box__thumb__container" },
                          [
                            _c("img", {
                              staticClass: "product-box__thumb",
                              attrs: { src: product.thumb, alt: "" },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "h4",
                          {
                            staticClass:
                              "product-box__name font__family--gotham font__weight--medium font__color--gray",
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                _vm._s(product.name) +
                                "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        product.additional_description
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "product-box__lead font__family--gotham font__weight--light font__color--gray-light text-uppercase mt-3",
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                    _vm._s(product.additional_description) +
                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", {
                          staticClass:
                            "product-box__subname font__family--gotham font__weight--light font__color--gray-light mt-4",
                          domProps: { innerHTML: _vm._s(product.desc) },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c(
                          "p",
                          {
                            staticClass:
                              "product-box__price font__family--gotham font__weight--medium font__color--gray",
                          },
                          [
                            product.is_simple
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("price_from", "products_list")
                                    ) + " "
                                  ),
                                ])
                              : _vm._e(),
                            _c("span", [_vm._v(_vm._s(product.price))]),
                            _vm._v(
                              "\n                                " +
                                _vm._s(product.currency) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "product-box__button button button__new button__new--blue",
                            attrs: { href: product.url },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("buy", "products_list"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "text-center pt-2 pb-5 mb-2" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "button button__size-1--bigger button__font--size-1 button__bg--invisible font__family--gotham font__weight--medium font__color--gray",
                    class: {
                      "d-none": _vm.showBtnMore,
                      "btn-loader btn-loader--close-to-right btn-loader--dark":
                        _vm.loader,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.loadMoreProducts.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("more_products", "products_list")) +
                        "\n                        "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ])
      : _c("div", {}, [
          _c(
            "p",
            {
              staticClass:
                "products-list__title font__family--gotham font__weight--light font__color--gray-light text-uppercase text-center mb-0 pt-2 pb-5",
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("no_products_to_show", "products_list")) +
                  "\n            "
              ),
            ]
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "ph-item" }, [
        _c("div", { staticClass: "ph-col-12" }, [
          _c("div", { staticClass: "ph-picture" }),
          _vm._v(" "),
          _c("div", { staticClass: "ph-row justify-content-center" }, [
            _c("div", { staticClass: "ph-col-8 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-10 big" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-10" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-20" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-12 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-12 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-4 big" }),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "ph-item" }, [
        _c("div", { staticClass: "ph-col-12" }, [
          _c("div", { staticClass: "ph-picture" }),
          _vm._v(" "),
          _c("div", { staticClass: "ph-row justify-content-center" }, [
            _c("div", { staticClass: "ph-col-8 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-10 big" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-10" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-20" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-12 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-12 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-4 big" }),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-4" }, [
      _c("div", { staticClass: "ph-item" }, [
        _c("div", { staticClass: "ph-col-12" }, [
          _c("div", { staticClass: "ph-picture" }),
          _vm._v(" "),
          _c("div", { staticClass: "ph-row justify-content-center" }, [
            _c("div", { staticClass: "ph-col-8 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-10 big" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-10" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-20" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-8" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-12 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-12 empty" }),
            _vm._v(" "),
            _c("div", { staticClass: "ph-col-4 big" }),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }